export enum PageViewType {
  SERP = 'SERP',
  PROJECT_PAGE_DIRECTORY = 'PROJECT_PAGE_DIRECTORY',
  PAGEVIEW_SERP_MAP = 'PAGEVIEW_SERP_MAP',
}
